{
  "title": "Mga gabay sa bayan",
  "lead": "Mga simpleng gabay mula sa mga opisinang humahawak ng bawat paksa, kasama ang kanilang mga darating na programa at serbisyo.",
  "emptyTitle": "Wala pang gabay",
  "emptyBody": "Wala pang inihahandang gabay sa bayan ang LGU.",
  "cardNoText": "Isinusulat pa ng opisina ang gabay na ito. Nakalista na ang kanilang mga programa at serbisyo.",
  "from": "Mula sa {offices}",
  "allGuides": "Lahat ng gabay sa bayan",
  "notFound": "Hindi available ang gabay na ito.",
  "notWrittenTitle": "Hindi pa naisusulat ang gabay na ito",
  "notWrittenBody": "Magdadagdag ng impormasyon dito ang {offices}. Habang hinihintay, tingnan sa ibaba ang kanilang mga pinakabagong post, programa at serbisyo.",
  "notWrittenNoOffice": "Malapit nang madagdagan ng impormasyon dito.",
  "linksTitle": "Mga kapaki-pakinabang na link",
  "postsTitle": "Mga programa, iskedyul at anunsiyo",
  "noPosts": "Wala pang naka-post ngayon. I-follow ang opisina para malaman ang mga bagong programa.",
  "servicesTitle": "Mga serbisyo",
  "noServices": "Hindi pa nakalista sa app ang mga serbisyo ng mga opisinang ito.",
  "allServices": "Tingnan ang lahat ng serbisyo",
  "contactTitle": "Makipag-ugnayan",
  "where": "Saan",
  "hours": "Oras ng opisina",
  "phone": "Telepono",
  "email": "Email",
  "noContact": "Hindi pa nailalathala ang mga detalye ng contact.",
  "staffLead": "Isulat ang mga gabay na hawak ng inyong opisina. Makikita ito ng mga residente sa Mga gabay sa bayan, kasama ng inyong mga post at serbisyo.",
  "staffEmptyTitle": "Walang gabay na nakatalaga sa inyong opisina",
  "staffEmptyBody": "Ang administrator ng LGU ang nagtatalaga ng mga gabay sa bayan sa mga opisina.",
  "statusPublished": "Nailathala",
  "statusNotPublished": "Hindi pa nailathala",
  "statusNotWritten": "Hindi pa naisusulat",
  "lastEdit": "Huling binago ni {who} ({office}) noong {date}",
  "neverEdited": "Hindi pa nababago",
  "view": "Tingnan",
  "backToList": "Bumalik sa inyong mga gabay",
  "editTitle": "I-edit: {title}",
  "sharedNote": "Hati sa {offices} ang gabay na ito. Puwedeng mag-edit ang alinman sa kanila; ang huling na-save ang makikita ng mga residente.",
  "summary": "Buod",
  "summaryHint": "Isa o dalawang pangungusap na makikita sa card ng gabay. {count} titik pa ang natitira.",
  "body": "Teksto ng gabay",
  "bodyHint": "Ang kailangang malaman ng mga residente: sino ang puwede, ano ang dadalhin, saan pupunta, mga iskedyul.",
  "linksHint": "Mga opisyal na pahina lamang, nagsisimula sa https://.",
  "linkLabel": "Teksto ng link",
  "linkUrl": "Address (https://…)",
  "removeLink": "Alisin ang link {n}",
  "addLink": "Magdagdag ng link",
  "coverTitle": "Larawan sa itaas",
  "coverHint": "Opsiyonal. Totoong larawan mula sa inyong opisina; hindi ipinapakita sa low-data mode.",
  "coverAlt": "Kasalukuyang larawan sa itaas",
  "addCover": "Magdagdag ng larawan",
  "replaceCover": "Palitan ang larawan",
  "removeCover": "Alisin ang larawan",
  "contactNote": "Paalala kung paano kayo makakausap",
  "contactNoteHint": "Halimbawa: \"Tumawag muna bago pumunta sa RHU.\"",
  "publish": "Ipakita ang gabay na ito sa mga residente",
  "publishHint": "Kapag naka-off, ang inyong mga post at serbisyo lang ang makikita ng mga residente sa pahinang ito.",
  "savedPublished": "Na-save. Makikita na ng mga residente ang gabay.",
  "savedDraft": "Na-save. Hindi pa ipinapakita sa mga residente ang gabay.",
  "adminPageTitle": "Mga gabay sa bayan",
  "adminLead": "Pagpasyahan kung aling mga gabay ang mayroon, aling mga opisina ang sumusulat ng bawat isa, at aling mga kategorya ng post ang lalabas dito. Ang pagkakasunod dito ang makikita ng mga residente.",
  "adminNew": "Bagong gabay",
  "adminEdit": "I-edit ang gabay",
  "adminEmpty": "Wala pang gabay",
  "adminSaved": "Na-save ang gabay.",
  "adminTitleField": "Pamagat",
  "adminIcon": "Icon",
  "adminOffices": "Mga opisinang sumusulat ng gabay na ito",
  "adminOfficesHint": "Ang kanilang staff ang nag-e-edit ng teksto; makikita sa gabay ang kanilang mga serbisyo at contact.",
  "adminBarangays": "Mga barangay ({count} ang napili)",
  "adminCategories": "Mga kategorya ng post na ipapakita",
  "adminCategoriesHint": "Lalabas sa gabay ang mga post sa mga kategoryang ito, mula sa kahit anong opisina. Kung wala, ang sariling mga post ng mga sumusulat na opisina ang lalabas.",
  "adminActive": "Ipakita ang gabay na ito",
  "adminActiveHint": "Mawawala sa app at sa listahan ng mga opisina ang mga nakatagong gabay.",
  "adminWrittenBy": "Isinusulat ng {offices}",
  "adminNoOffices": "Walang nakatalagang opisina",
  "adminShowsPosts": "Ipinapakita ang mga post sa: {categories}",
  "adminInactive": "Nakatago",
  "moveUp": "Iakyat ang {title}",
  "moveDown": "Ibaba ang {title}",
  "viewNamed": "Tingnan ang {title}",
  "editNamed": "I-edit ang {title}"
}
